import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var DeletePlayerCommandClass;
function DeletePlayerCommand() {
  if (DeletePlayerCommandClass === VOID) {
    class $ {
      constructor(partyId, playerId) {
        this.s2l_1 = partyId;
        this.t2l_1 = playerId;
      }
      toString() {
        return 'DeletePlayerCommand(partyId=' + this.s2l_1.toString() + ', playerId=' + this.t2l_1.toString() + ')';
      }
      hashCode() {
        var result = this.s2l_1.hashCode();
        result = imul(result, 31) + this.t2l_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePlayerCommand()))
          return false;
        if (!this.s2l_1.equals(other.s2l_1))
          return false;
        if (!this.t2l_1.equals(other.t2l_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePlayerCommand');
    DeletePlayerCommandClass = $;
  }
  return DeletePlayerCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher1dgi8c7arrsv1,
  DeletePlayerCommand as DeletePlayerCommand2zoj1uvzio0vl,
};
//endregion

//# sourceMappingURL=DeletePlayerCommand.mjs.map
